// extracted by mini-css-extract-plugin
module.exports = {"main":"NavbarItem_main__1ZAS-","activeTab":"NavbarItem_activeTab__1zwNp"};